<div class="container">
  <h1 class="rounded text-center ">Discharge Reason Report</h1>

  <div class="d-flex gap-2">
    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate  [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>


    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Centre</mat-label>
      <mat-select [(value)]="centreCode" >
        <mat-option *ngFor="let c of centres|async" [value]="c.centreCode"> {{c.centreName}}</mat-option>
      </mat-select>
    </mat-form-field>

<button mat-mini-fab (click)="search()"  color="accent"><mat-icon>search</mat-icon></button>


  </div>


</div>
